<!--
  One child entity of the open bd.DunningType as a framework table widget. The widget is rebuilt
  whenever the bound descriptor or the DunningType id changes (see ngOnChanges) — the parent reuses
  a single instance of this component across navigation items.
-->
<div class="bd-dunning-type-child-table">

    @if (childWidget) {

        <mvs-widget
                [widgetData]="childWidget"
                [importObjectContext]="importContext">
        </mvs-widget>

    } @else {

        <p-skeleton height="20rem" styleClass="w-full"></p-skeleton>

    }

</div>
